/* eslint-disable no-undef */
import firebase from "firebase";
import store from "@/store/";

// Firebase Config
const config = {
	apiKey: process.env.FIREBASE_API_KEY,
	authDomain: process.env.FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.FIREBASE_DATABASE_URL,
	databasecloudfunctionsUrl: process.env.FIREBASE_CLOUDFUNCTIONS_URL,
	projectId: process.env.FIREBASE_PROJECT_ID,
	storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.FIREBASE_MESSAGE_SENDER_ID,
	appId: process.env.FIREBASE_APP_ID,	
	measurementId: process.env.FIREBASE_MEASUREMENT_ID
};
// Initialize Firebase
firebase.initializeApp(config);

// Firebase Auth Objects
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const auth = firebase.auth();

function signin() {
	return firebase.auth().signInWithRedirect(googleAuthProvider)
		.catch(function(error) {
			console.error("error.message :", error.message);
			console.error("error.code :", error.code);
			console.error("error.credential :", error.credential);
			console.error("error.email :", error.email);
		});
}

function signout() {
	return firebase.auth().signOut().then(() => {
		this.$router.push("/");
	});
}

function setAdministrator(user, administratorsEmail) {
	let payload = {
		user: user,
		administratorsEmail: administratorsEmail
	};
	this.$store.dispatch("SET_ADMINISTRATOR", payload);
}

export {
	auth,
	signin,
	signout,
	setAdministrator
};


// WEBPACK FOOTER //
// ./src/vue-service-auth.js